export default __webpack_public_path__ + "static/media/undraw_file_searching.091d4a89.svg";